// https://api.github.com/searchs/michaelbenin
// import { canUseDOM } from 'exenv';

export function searchLoading(search = {}, store = {}) {
  return {
    type: 'SEARCH_LOADING',
    search,
    store
  };
}

export function searchLoaded(search, store = {}) {
  return {
    type: 'SEARCH_LOADED',
    search,
    store
  };
}

export function searchError(error, query, store = {}) {
  return {
    type: 'SEARCH_ERROR',
    search: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message',
      query
    },
    store
  };
}
